import { render } from "./Support_Session_Desktop.vue?vue&type=template&id=57baaa66&scoped=true"
import script from "./Support_Session_Desktop.vue?vue&type=script&lang=js"
export * from "./Support_Session_Desktop.vue?vue&type=script&lang=js"

import "./Support_Session_Desktop.vue?vue&type=style&index=0&id=57baaa66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57baaa66"]])

export default __exports__